import { colors } from 'src/constants/colors';
import { TSvgIcon } from 'src/types/common.types';
const BlogIcon = ({ color = colors.neutral[600], ...rest }: TSvgIcon) => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="#fff" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.33 13.49L8.71 10.4C9.05 9.96 9.68 9.88 10.12 10.22L11.95 11.66C12.39 12 13.02 11.92 13.36 11.49L15.67 8.51M8 21H14C19 21 21 19 21 14V8C21 3 19 1 14 1H8C3 1 1 3 1 8V14C1 19 3 21 8 21Z" stroke="#535353" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
}
export default BlogIcon
